import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import { Building2 } from "lucide-react";
import Suppliers from "./Suppliers";
import SupplierInsights from "./SupplierInsights";
import SupplierPortalAdmin from "./SupplierPortalAdmin";
import ProductsTraceability from "./ProductsTraceability";
import DataExchange from "./DataExchange";
import ControlTower from "./ControlTower";
import SupplierCampaigns from "./SupplierCampaigns";
import SupplierDisclosures from "./SupplierDisclosures";
import SupplierActionPlans from "./SupplierActionPlans";
import Scope3Intelligence from "./Scope3Intelligence";

// S-004 — a single, non-contradictory Suppliers destination. The three former
// sub-tabs (Engagement, Insights, Portal Admin) now live behind one view.
export default function SuppliersHub() {
  return (
    <div className="p-6 lg:p-8" data-testid="suppliers-hub-page">
      <div className="mb-4">
        <div className="label-eyebrow mb-1">Supply Chain</div>
        <h1 className="font-display text-4xl font-bold tracking-tighter flex items-center gap-3">
          <Building2 className="h-8 w-8 text-accent" /> Suppliers
        </h1>
        <p className="text-muted-foreground text-sm mt-1 max-w-2xl">
          Engagement, ESG insights and portal administration for your supply chain — one place to look.
        </p>
      </div>
      <Tabs defaultValue="control-tower">
        <TabsList className="flex flex-wrap h-auto">
          <TabsTrigger value="control-tower" data-testid="suppliers-tab-control-tower">Control Tower</TabsTrigger>
          <TabsTrigger value="engagement" data-testid="suppliers-tab-engagement">Engagement</TabsTrigger>
          <TabsTrigger value="campaigns" data-testid="suppliers-tab-campaigns">Campaigns</TabsTrigger>
          <TabsTrigger value="products" data-testid="suppliers-tab-products">Products & Traceability</TabsTrigger>
          <TabsTrigger value="disclosures" data-testid="suppliers-tab-disclosures">Disclosures</TabsTrigger>
          <TabsTrigger value="action-plans" data-testid="suppliers-tab-action-plans">Action Plans</TabsTrigger>
          <TabsTrigger value="intelligence" data-testid="suppliers-tab-intelligence">Intelligence ✦</TabsTrigger>
          <TabsTrigger value="insights" data-testid="suppliers-tab-insights">Insights</TabsTrigger>
          <TabsTrigger value="exchange" data-testid="suppliers-tab-exchange">Data Exchange</TabsTrigger>
          <TabsTrigger value="portal" data-testid="suppliers-tab-portal">Portal Admin</TabsTrigger>
        </TabsList>
        <TabsContent value="control-tower" className="-mx-6 lg:-mx-8 mt-0"><ControlTower /></TabsContent>
        <TabsContent value="engagement" className="-mx-6 lg:-mx-8 mt-0"><Suppliers /></TabsContent>
        <TabsContent value="campaigns" className="-mx-6 lg:-mx-8 mt-0"><SupplierCampaigns /></TabsContent>
        <TabsContent value="products" className="-mx-6 lg:-mx-8 mt-0"><ProductsTraceability /></TabsContent>
        <TabsContent value="disclosures" className="-mx-6 lg:-mx-8 mt-0"><SupplierDisclosures /></TabsContent>
        <TabsContent value="action-plans" className="-mx-6 lg:-mx-8 mt-0"><SupplierActionPlans /></TabsContent>
        <TabsContent value="intelligence" className="-mx-6 lg:-mx-8 mt-0"><Scope3Intelligence /></TabsContent>
        <TabsContent value="insights" className="-mx-6 lg:-mx-8 mt-0"><SupplierInsights /></TabsContent>
        <TabsContent value="exchange" className="-mx-6 lg:-mx-8 mt-0"><DataExchange /></TabsContent>
        <TabsContent value="portal" className="-mx-6 lg:-mx-8 mt-0"><SupplierPortalAdmin /></TabsContent>
      </Tabs>
    </div>
  );
}
